"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
exports.default = { randomUUID };
